import React from 'react';
import ReactDOM from 'react-dom';
import {Router,Switch,Route} from 'react-router-dom';
import App from './components/App';
import Projects from './components/Projects';
import createBroweserHistory from 'history/createBrowserHistory';

ReactDOM.render(
    <Router history={createBroweserHistory()}>
        <Switch>
            <Route exact path='/' component={App} />
            <Route path='/projects' component={Projects} />
        </Switch>
    </Router>,
    document.getElementById('root')
);
